export const AUTO_TRANSLATION_TARGET = 'auto';

// Languages the mobile app ships in come first, then the most common ones across our workforces
export const TRANSLATION_LANGUAGES = [
  'English',
  'Romanian',
  'Lithuanian',
  'Russian',
  'Polish',
  'Bulgarian',
  'Ukrainian',
  'Portuguese',
  'Spanish',
  'Italian',
  'Latvian',
  'Hungarian',
  'Albanian',
  'Turkish',
  'Punjabi',
  'Urdu',
  'Hindi',
];
